import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import ViewMoreButtonDesktop, { ViewMoreButtonMobile } from "../WebButton/ViewMoreButton";
import { useParams } from 'react-router-dom';
import './Article.css'
import HorizontalAd from '../Ads/HorizontalAd';
import RealtedArticel from '../RelatedArticel/RelatedArticel';
import WhiteStorieCard from '../StorieCards/White/WhiteStorieCard';
import { useAppContext } from '../Context/AppContext';
import Cookies from 'js-cookie';
import parse from 'html-react-parser';
import Meta from '../Meta/Meta';
import Share from '../Share/Share';
import youtube from '../logos/youtube.png'
import Videos from '../Videos/Videos';

const Article = () => {
    const { BASE_PATH } = useContext(useAppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [relatedtitle, setRelatedtitle] = useState();
    const [trendingtitle, setTrendingtitle] = useState();
    const [type, setType] = useState();
    const { categoryname, articlename } = useParams();

    if (!Cookies.get('lg')) {
        Cookies.set('lg', 'en');
    }

    const language = Cookies.get('lg');

    useEffect(() => {
        if (categoryname == 'videos' || categoryname == 'paparazzi' || categoryname == 'trailers' || categoryname == 'वीडियोस' || categoryname == 'पेप्पराज़ी' || categoryname == 'ट्रेलर' || categoryname == 'వీడియోస్' || categoryname == 'ఫిల్మ్-ఈవెంట్స్' || categoryname == 'ట్రైలర్స్' || categoryname == 'RJ-Suneetha-కబుర్లు') {
            fetchData('videos');
            setType('videos');
        } else {
            fetchData('article');
            setType('article');
        }
    }, [])


    const fetchData = async (artcletype) => {
        const response = await fetch("https://mobilemasala.com:9093/" + language + "/articlepage?type=" + artcletype + "&category=" + categoryname + "&article=" + articlename, {
            method: "POST"
        })
        const finaldata = await response.json()
        setData(finaldata.data)
        setIsLoading(false);

        if (language === 'en') {
            setRelatedtitle('Related');
            setTrendingtitle('Trending');
        }

        if (language === 'tl') {
            setRelatedtitle('రిలేటెడ్');
            setTrendingtitle('ట్రెండింగ్');
        }

        if (language === 'hi') {
            setRelatedtitle('रिलेटेड');
            setTrendingtitle('ट्रेंडिंग');
        }
    }

    if (isLoading) {
        return <div></div>;
    }

    const { image, description, title, categorytitle, categoryurl, date, video, comments } = data.articledata;

    const final_data = () => {
        if (type === 'article') {
            return (
                <>
                    <section className='article pt-1'>
                        <Container>
                            <Row className='article-row'>
                                <Col>
                                    <img src={image} alt={title} />
                                    <div className='description pt-2'>
                                        <div className='whitetitle '>
                                            <h2>{title}</h2>
                                        </div>
                                        <p>{date}</p>
                                        <div>
                                            {description && parse(description)}
                                        </div>
                                    </div>
                                    <div className='p-3 border rounded my-3'>
                                        <h6>Top Comments</h6>

                                        <InputGroup className="mb-3">
                                            <Form.Control aria-label="comment" placeholder='Write a comment' />
                                            <InputGroup.Text>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" className="bi bi-send" viewBox="0 0 16 16">
                                                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                                                </svg>
                                            </InputGroup.Text>
                                        </InputGroup>
                                        {
                                            comments.length > 0 ? (
                                                comments.map((data, index) => {
                                                    return (
                                                        <>
                                                            <div key={index} className='d-flex'>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                                                                    <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                                                                </svg> <p className='ps-2'>{data.comment}</p>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                            ) : (
                                                <p>There are no comments in this article yet. Be first to post one!</p>
                                            )
                                        }
                                    </div>
                                    <Share shareUrl={decodeURI(window.location.href)} title={title} className="text-center" />
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <HorizontalAd />
                    <RealtedArticel title={relatedtitle} url={categoryurl}>{data.relatedarticledata}</RealtedArticel>
                    <HorizontalAd />
                    <WhiteStorieCard title={trendingtitle} url={categoryurl}>{data.categoryarticle}</WhiteStorieCard>
                    <HorizontalAd />
                </>

            )
        } else {
            return (
                <>
                    <section className='article pt-1'>
                        <Container>
                            <Row className='article-row'>
                                <Col>
                                    <div className='video-section mb-3'>
                                        <iframe id="ytplayer" height="100%" width="100%" type="text/html"
                                            src={video + '?autoplay=1&loop=1'} frameBorder="0" allow="autoplay" />
                                    </div>
                                    <div className='description pt-2'>
                                        <div className='whitetitle '>
                                            <h2>{title}</h2>
                                        </div>
                                        <p>{date}</p>
                                        <div>
                                            {description && parse(description)}
                                        </div>
                                    </div>
                                    <div className='p-3 border rounded my-3'>
                                        <h6>Top Comments</h6>

                                        <InputGroup className="mb-3">
                                            <Form.Control aria-label="comment" placeholder='Write a comment' />
                                            <InputGroup.Text>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" className="bi bi-send" viewBox="0 0 16 16">
                                                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                                                </svg>
                                            </InputGroup.Text>
                                        </InputGroup>
                                        {
                                            comments.length > 0 ? (
                                                comments.map((data, index) => {
                                                    return (
                                                        <>
                                                            <div key={index} className='d-flex'>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                                                                    <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                                                                </svg> <p className='ps-2'>{data.comment}</p>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                            ) : (
                                                <p>There are no comments in this article yet. Be first to post one!</p>
                                            )
                                        }
                                    </div>
                                    <Share shareUrl={window.location.href} title={title} className="text-center" />
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <HorizontalAd />
                    <section className="relatedarticel article_youtube">
                        <Container>
                            <Row>
                                <div className='whitetitle'>
                                    <h2>{relatedtitle}</h2>
                                </div>
                            </Row>
                            <Row>
                                {/* <Col lg={6} md={12} sm={12} xs={12} className="align-items-center d-flex" > */}
                                <Col lg={6} md={12} sm={12} xs={12}  >
                                    <Card >
                                        <div className='position-relative'>
                                            <Card.Img variant="top" src={data.relatedarticledata[0].image} alt={title} loading="lazy" />
                                            <Card.Link href={`${BASE_PATH}${data.relatedarticledata[0].categoryurl}/${data.relatedarticledata[0].articleurl}`} className='icon'>
                                                <img src={youtube} alt="youtube" />
                                            </Card.Link>
                                        </div>
                                        <Card.Body>
                                            <Card.Text className='card-category'>{categorytitle} </Card.Text>
                                            <Card.Link href={`${BASE_PATH}${data.relatedarticledata[0].categoryurl}/${data.relatedarticledata[0].articleurl}`}>
                                                <Card.Title className="word-line-limit3 first-artical-title">{data.relatedarticledata[0].title}</Card.Title>
                                            </Card.Link>
                                            <Card.Text className='card-date'>
                                                {/* {cardArticel.date} */}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col lg={6} md={12} sm={12} xs={12} >
                                    <Row>
                                        <Col lg={6} md={6} sm={6} xs={6} >
                                            <Card >
                                                <div className='position-relative'>
                                                    <Card.Img variant="top" src={data.relatedarticledata[1].image} alt={title} loading="lazy" />
                                                    <Card.Link href={`${BASE_PATH}${data.relatedarticledata[1].categoryurl}/${data.relatedarticledata[1].articleurl}`} className='icon'>
                                                        <img src={youtube} alt="youtube" />
                                                    </Card.Link>
                                                </div>
                                                <Card.Body>
                                                    <Card.Text className='card-category'>{categorytitle} </Card.Text>
                                                    <Card.Link href={`${BASE_PATH}${data.relatedarticledata[1].categoryurl}/${data.relatedarticledata[1].articleurl}`}>
                                                        <Card.Title className='word-line-limit'>{data.relatedarticledata[1].title}</Card.Title>
                                                    </Card.Link>
                                                    <Card.Text className='card-date'>
                                                        {/* {cardArticel.date} */}
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col lg={6} md={6} sm={6} xs={6} >
                                            <Card >
                                                <div className='position-relative'>
                                                    <Card.Img variant="top" src={data.relatedarticledata[2].image} alt={title} loading="lazy" />
                                                    <Card.Link href={`${BASE_PATH}${data.relatedarticledata[2].categoryurl}/${data.relatedarticledata[2].articleurl}`} className='icon'>
                                                        <img src={youtube} alt="youtube" />
                                                    </Card.Link>
                                                </div>
                                                <Card.Body>
                                                    <Card.Text className='card-category'>{categorytitle} </Card.Text>
                                                    <Card.Link href={`${BASE_PATH}${data.relatedarticledata[2].categoryurl}/${data.relatedarticledata[2].articleurl}`}>
                                                        <Card.Title className='word-line-limit'>{data.relatedarticledata[2].title}</Card.Title>
                                                    </Card.Link>
                                                    <Card.Text className='card-date'>
                                                        {/* {cardArticel.date} */}
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={6} xs={6} >
                                            <Card >
                                                <div className='position-relative'>
                                                    <Card.Img variant="top" src={data.relatedarticledata[3].image} alt={title} loading="lazy" />
                                                    <Card.Link href={`${BASE_PATH}${data.relatedarticledata[3].categoryurl}/${data.relatedarticledata[3].articleurl}`} className='icon'>
                                                        <img src={youtube} alt="youtube" />
                                                    </Card.Link>
                                                </div>
                                                <Card.Body>
                                                    <Card.Text className='card-category'>{categorytitle} </Card.Text>
                                                    <Card.Link href={`${BASE_PATH}${data.relatedarticledata[3].categoryurl}/${data.relatedarticledata[3].articleurl}`}>
                                                        <Card.Title className='word-line-limit'>{data.relatedarticledata[3].title}</Card.Title>
                                                    </Card.Link>
                                                    <Card.Text className='card-date'>
                                                        {/* {cardArticel.date} */}
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col lg={6} md={6} sm={6} xs={6} >
                                            <Card >
                                                <div className='position-relative'>
                                                    <Card.Img variant="top" src={data.relatedarticledata[4].image} alt={title} loading="lazy" />
                                                    <Card.Link href={`${BASE_PATH}${data.relatedarticledata[4].categoryurl}/${data.relatedarticledata[4].articleurl}`} className='icon'>
                                                        <img src={youtube} alt="youtube" />
                                                    </Card.Link>
                                                </div>
                                                <Card.Body>
                                                    <Card.Text className='card-category'>{categorytitle} </Card.Text>
                                                    <Card.Link href={`${BASE_PATH}${data.relatedarticledata[4].categoryurl}/${data.relatedarticledata[4].articleurl}`}>
                                                        <Card.Title className='word-line-limit'>{data.relatedarticledata[4].title}</Card.Title>
                                                    </Card.Link>
                                                    <Card.Text className='card-date'>
                                                        {/* {cardArticel.date} */}
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <ViewMoreButtonMobile redirect={data.relatedarticledata[0].categoryurl} />
                        </Container>
                    </section >
                    <HorizontalAd />
                    <WhiteStorieCard title={trendingtitle} url={categoryurl}>{data.categoryarticle}</WhiteStorieCard>
                    <HorizontalAd />
                </>
            )
        }
    }

    return (
        <>
            <Meta metadata={data.metadata} />
            {final_data()}

        </>
    )
}

export default Article;







